import { getInstance, getNamespace } from '@ctct/distui-helpers';

export const getCustomerEmail = async () => {
  const DistUI = await getInstance();

  return DistUI.getCustomer().contactEmail;
};

export const getCustomerCurrency = async () => {
  const DistUI = await getInstance();

  return DistUI?.getAccountData?.().billingCustomer?.currencyCd ?? null;
};

export const getDisabledActivities = async () => {
  const DistUI = await getInstance();

  return DistUI?.getAccountData?.().planGroup?.disabledActivities ?? null;
};

export const getBillingCustomerCurrency = async (defaultCurrencyCode = 'USD') => {
  const customerCurrency = await getCustomerCurrency();

  return customerCurrency ?? defaultCurrencyCode;
};

export const getCustomerAudit = async () => {
  const DistUI = await getInstance();

  return DistUI.getCustomer().audit;
};

export const getAccountData = async () => {
  const DistUI = await getInstance();

  const planDetail = DistUI.getPlanDetail();
  const isCanceled = DistUI.isCanceled();
  const isTrialer = DistUI.isTrialer();

  return {
    planDetail,
    isCanceled,
    isTrialer,
  };
};

export const getIsManagedAccount = async () => {
  const DistUI = await getInstance();

  const { partnerType } = await DistUI.getPartnerSummary();

  return partnerType === '7' || partnerType === '8';
};

export const getPrivileges = async () => {
  const DistUI = await getInstance();

  return DistUI.getPrivileges() || {};
};

export const getAccount = async () => {
  const DistUI = await getNamespace();

  return DistUI.account;
};

export const getAccountId = async () => {
  const DistUI = await getInstance();

  return DistUI.getAccountId();
};

export const getAccountRole = async () => {
  const DistUI = await getInstance();

  return DistUI.getRole();
};

export const getBusinessType = async () => {
  const DistUI = await getInstance();

  return DistUI.getCustomer().demographics.businessType;
};

export const getProductAccount = async () => {
  const DistUI = await getInstance();

  return DistUI.getProductAccount();
};

export const getPastDueBalance = async () => {
  const DistUI = await getInstance();

  return DistUI.getPastDueBalance();
};

export const isCanceled = async () => {
  const DistUI = await getInstance();

  return DistUI.isCanceled();
};

export const clearUserCache = async () => {
  await getNamespace().then(({ manageCache }) => manageCache.clearUserCache());
};

export const distUiGoTo = async (where, ...other) => {
  const DistUI = await getInstance();

  DistUI.goTo(where, ...other);
};

export const getUserName = async () => {
  const DistUI = await getInstance();

  return DistUI.getUserName();
};

export const getPartnerName = async () => {
  const DistUI = await getInstance();

  const { partnerName } = await DistUI.getPartnerSummary();

  return partnerName;
};

export const getTealiumData = async () => {
  const namespace = await getNamespace();
  const tealiumData = await namespace.tracking.getTealiumData();

  return tealiumData;
};

export const getPartnerOwnerSummary = async () => {
  const DistUI = await getInstance();

  if (DistUI && DistUI.getAccountData) {
    return DistUI.getAccountData().partnerOwnerSummary;
  }

  return null;
};

export const getParentPartnerSummary = async () => {
  const DistUI = await getInstance();

  if (DistUI && DistUI.getAccountData) {
    return DistUI.getAccountData().partnerSummary;
  }

  return null;
};

export const getIsSingleBilled = async () => {
  const DistUI = await getInstance();

  if (DistUI && DistUI.getAccountData) {
    return DistUI.getAccountData().isSingleBilled;
  }

  return null;
};

export const getIsTrialer = async () => {
  const DistUI = await getInstance();

  return DistUI.isTrialer();
};

export const getIsSuspended = async () => {
  const DistUI = await getInstance();

  return DistUI.isSuspended();
};

export const getCustomer = async () => {
  const DistUI = await getInstance();

  return DistUI.getCustomer();
};

export const getCountryCode = async () => {
  const namespace = await getNamespace();

  return namespace.account.getCountryCode();
};

export const getFeatureSwitch = async (app, page) => {
  const { featureSwitches } = await getNamespace();

  return featureSwitches.getFeatureSwitch(app, page);
};
